import { Injectable, Inject } from '@angular/core';
import { AuthHttp } from 'angular2-jwt';
import { APIBase } from './api.base';
import { Router } from '@angular/router';
import { SessionStorageService } from '../services/session-storage.service';

@Injectable()
export class BanksAPI extends APIBase {

	constructor(@Inject(AuthHttp) authHttp: AuthHttp, @Inject(Router) router: Router, @Inject(SessionStorageService) session: SessionStorageService) {
		super(authHttp, router, session);

		// Entidade principal
		this.__entity = 'banks';
	}

	/**
	 * getListBanks
	 *
	 * @access public
	 * @author Elian Medeiros
	 * @since  05/2018
	 * @param  string
	 * @return object Promise
	 */
	public getListBanks() {
		return this._call(this.__entity+'/bank_list', {}, 'get');
	}
}


// WEBPACK FOOTER //
// ./src/api/banks.api.ts